/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';

// ui widget mjDialogTabs

(function($) {


	var defaults = {
		tabs: [],
	};

	var methods = {
		init: function( options ) {
			//var outer_this = this;
			return this.each( function() {
				var self = $(this),
					opts = Object.assign({},defaults,options)
					;
				self.append('<table class="dlg-tabs"><tbody><tr></tr><tbody></table>');
				var tabs_tr = self.children('.dlg-tabs').children('tbody').children('tr');
				for( var i=0; i<opts.tabs.length; ++i ) {
					var tab = opts.tabs[i];
					if( i==0 ) tabs_tr.append('<td class="first-tab-inactive"></td>');
					else tabs_tr.append('<td class="between-tab-inactive-inactive"></td>');
					tabs_tr.append('<td class="tab-inactive dlg-tab-'+tab.id+'">'+tab.html+'</td>');
				}
				tabs_tr.append('<td class="last-tab-inactive"></td>');
				tabs_tr.append('<td class="tab-status status"></td>');
			} );
		},
		activate: function( id ) {
			//var outer_this = this;
			return this.each( function() {
				var self = $(this);
				var tabs_tr = self.find('> .dlg-tabs tr');
				var tabs_td = tabs_tr.children('td');
				// set inactive state on all columns
				tabs_td.each( function() {
					var td = $(this);
					if( td.hasClass('tab-active') ) td.removeClass('tab-active').addClass('tab-inactive');
					else if( td.hasClass('between-tab-inactive-active') || td.hasClass('between-tab-active-inactive') ) td.removeClass('between-tab-active-inactive between-tab-inactive-active').addClass('between-tab-inactive-inactive');
					else if( td.hasClass('first-tab-active') ) td.removeClass('first-tab-active').addClass('first-tab-inactive');
					else if( td.hasClass('last-tab-active') ) td.removeClass('last-tab-active').addClass('last-tab-inactive');
				} );
				// set active state on selected column
				var active_td = tabs_td.filter('.dlg-tab-'+id);	//tabs_tr.children('td.dlg-tab-'+id);
				if( active_td.length ) {
					active_td.removeClass('tab-inactive').addClass('tab-active');
					var prev = active_td.prev(),
						next = active_td.next();
					if( prev.hasClass('first-tab-inactive') ) prev.removeClass('first-tab-inactive').addClass('first-tab-active');
					else prev.removeClass('between-tab-inactive-inactive').addClass('between-tab-inactive-active');
					if( next.hasClass('last-tab-inactive') ) next.removeClass('last-tab-inactive').addClass('last-tab-active');
					else next.removeClass('between-tab-inactive-inactive').addClass('between-tab-active-inactive');
				}
			} );
		},
		toggle: function( id, toggle ) {
			return this.each( function() {
				var self = $(this);
				var tabs_tr = self.find('> .dlg-tabs tr');
				var tabs_td = tabs_tr.children('td');
				var toggling_td = tabs_td.filter('.dlg-tab-'+id);
				toggling_td.toggle(!!toggle);
			} );
		},
		status: function( text ) {
			//var outer_this = this;
			return this.each( function() {
				var self = $(this),
					tabs_tr = self.find('> .dlg-tabs tr'),
					tab_status = tabs_tr.children('td.tab-status').empty();
				if( text.length>0 ) $('<span></span>').text(text).appendTo(tab_status);
			});
		},
		destroy: function() {
			//var outer_this = this;
			return this.each( function() {
				$(this).remove('.dlg-tabs');
			} );
		},
	};

	$.fn.mjDialogTabs = function( method ) {
		if( methods[method] ) {
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		} else if( typeof method === 'object' || !method ) {
			return methods.init.apply(this,arguments);
		}
		$.error( 'Method '+method+' does not exist on jQuery.mjDialogTabs' );

	};

})(jQuery);

